import(/* webpackMode: "eager", webpackExports: ["StaticPage"] */ "/app/src/components/StaticPage/index.tsx");
